import { bus_trangthai_dangky } from '../../models/response/bus/bus_trangthai_dangky';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_BUS_TRANGTHAI_DANGKY_PATH = "bus/trangthai-dangky";

class BusTrangThaiDangKyApi extends BaseCRUDApi<bus_trangthai_dangky> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
}
export const busTrangThaiDangKyApi = new BusTrangThaiDangKyApi(API_BUS_TRANGTHAI_DANGKY_PATH);
